const navigation = {
  navbar: {
    home: "首頁",
    dashboard: "儀表板",
    profile: "個人資料",
    settings: "設定",
    signIn: "登入",
    signUp: "註冊",
    signOut: "登出",
  },

  nav: {
    dashboard: "儀表板",
    settings: "設定",
    logout: "登出",
  },

  app: {
    title: "紫微斗數",
    subtitle: "紫微命理學",
  },
};

export default navigation;
